(() => {
  if (window.ppCreatorCredits) { window.ppCreatorCredits.init(document); return; }
  const instances = new Map();
  const saveStyle = (element, names) => names.map(name => [name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)]);
  const restoreStyle = (element, saved) => saved.forEach(([name, value, priority]) => value ? element.style.setProperty(name, value, priority) : element.style.removeProperty(name));
  function init(scope) {
    scope.querySelectorAll('[data-pp-creator-credits]').forEach(root => {
      if (instances.has(root)) return;
      const dialog = root.querySelector('dialog');
      const info = root.closest('product-info');
      if (!info || !dialog || typeof dialog.showModal !== 'function') return;
      const candidates = [...info.querySelectorAll('p.product__text > span')].filter(node => {
        const text = node.textContent || '';
        return text.includes('🎨') && text.includes('ⓘ');
      });
      if (candidates.length !== 1) return;
      const span = candidates[0];
      if (span.querySelector('button')) return;
      const marked = [...span.querySelectorAll('u, span')].filter(node => {
        const text = node.textContent || '';
        const style = getComputedStyle(node);
        return /ⓘ\s*$/.test(text) &&
          (node.matches('u') || style.textDecorationLine.includes('underline') || style.textDecoration.includes('underline'));
      });
      if (marked.length !== 1) return;
      const credit = marked[0];
      const labelText = credit.textContent.replace(/\s*ⓘ\s*$/, '');
      const original = span.innerHTML;
      const trigger = document.createElement('button');
      trigger.type = 'button'; trigger.className = 'pp-creator-trigger';
      trigger.setAttribute('aria-haspopup', 'dialog'); trigger.setAttribute('aria-controls', dialog.id); trigger.setAttribute('aria-expanded', 'false');
      const label = document.createElement('span'); label.className = 'pp-creator-trigger-label'; label.textContent = labelText;
      const icon = document.createElement('span'); icon.textContent = 'ⓘ'; icon.setAttribute('aria-hidden', 'true');
      trigger.append(label, document.createTextNode(' '), icon);
      credit.replaceWith(trigger);
      const controller = new AbortController();
      const on = (element, name, handler) => element.addEventListener(name, handler, { signal: controller.signal });
      let saved = null, outsidePointer = null;
      function restore(returnFocus = true) {
        if (!saved) return;
        const state = saved; saved = null;
        restoreStyle(document.body, state.body);
        // Restore the exact scroll position before restoring any smooth-scroll rule.
        window.scrollTo({ left: state.x, top: state.y, behavior: 'instant' });
        restoreStyle(document.documentElement, state.html);
        trigger.setAttribute('aria-expanded', 'false'); outsidePointer = null;
        if (returnFocus && trigger.isConnected) trigger.focus({ preventScroll: true });
      }
      function close(returnFocus = true) { if (dialog.open) dialog.close(); restore(returnFocus); }
      function open() {
        if (dialog.open) return;
        saved = { x: window.scrollX, y: window.scrollY,
          body: saveStyle(document.body, ['position', 'top', 'left', 'width', 'overflow']),
          html: saveStyle(document.documentElement, ['overflow', 'scroll-behavior']) };
        document.documentElement.style.setProperty('scroll-behavior', 'auto');
        document.documentElement.style.overflow = 'hidden';
        Object.assign(document.body.style, { position: 'fixed', top: -saved.y + 'px', left: -saved.x + 'px', width: '100%', overflow: 'hidden' });
        try {
          dialog.showModal(); trigger.setAttribute('aria-expanded', 'true');
          root.querySelector('.pp-credits-close').focus({ preventScroll: true });
        } catch (error) { restore(); console.error('Petrol Post creator dialog could not open', error); }
      }
      const outside = event => { const r = dialog.getBoundingClientRect(); return event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom; };
      on(trigger, 'click', open);
      root.querySelectorAll('[data-pp-close]').forEach(button => on(button, 'click', () => close()));
      on(dialog, 'cancel', event => { event.preventDefault(); close(); });
      on(dialog, 'close', () => { if (!dialog.open) restore(); });
      on(dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const buttons = [...dialog.querySelectorAll('[data-pp-close]')];
        const first = buttons[0], last = buttons[buttons.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      });
      on(dialog, 'pointerdown', event => { outsidePointer = outside(event) ? event.pointerId : null; });
      on(dialog, 'pointerup', event => { if (outsidePointer === event.pointerId && outside(event)) close(); outsidePointer = null; });
      on(dialog, 'pointercancel', () => { outsidePointer = null; });
      instances.set(root, () => { close(false); controller.abort(); if (span.isConnected) span.innerHTML = original; instances.delete(root); });
    });
  }
  window.ppCreatorCredits = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, cleanup] of instances) if (event.target.contains(root)) cleanup();
  });
})();
